"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PropUtils = require("../../util/PropUtils");

/**
 * @class ButtonGroup
 * @desc The grouped buttons in a dialog
 *
 * @param {string} [data-id="button-group"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *      css paramanter
 * @param {string} [cancelLabel="Cancel"]
 *      Text to show in the cancel link
 * @param {function} [onCancel]
 *      Callback for when the cancel link is clicked. Cancel link only appears when this is defined.
 */
var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      cancelLabel = _ref.cancelLabel,
      dataId = _ref["data-id"],
      onCancel = _ref.onCancel;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("button-group", className),
    "data-id": dataId
  }, children, onCancel && [/*#__PURE__*/_react.default.createElement("br", {
    key: "break"
  }), /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    key: "cancel",
    className: "cancel",
    "data-id": "button-group-cancel"
  }, (0, _PropUtils.getClickableA11yProps)(onCancel), {
    onClick: onCancel
  }), cancelLabel)]);
};

ButtonGroup.propTypes = {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  cancelLabel: _propTypes.default.string,
  onCancel: _propTypes.default.func
};
ButtonGroup.defaultProps = {
  "data-id": "button-group",
  cancelLabel: "Cancel"
};
var _default = ButtonGroup;
exports.default = _default;
module.exports = exports["default"];